<template>
  <div style="position: relative; height: 320px">
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
import Chart from "chart.js/auto";

export default {
  name: "viz-chart",
  // type: "bar" | "line" | "pie" | "doughnut"; data/options: Chart.js config objects.
  props: {
    type: { type: String, default: "bar" },
    data: { type: Object, required: true },
    options: { type: Object, default: () => ({}) },
  },
  data() {
    return { chart: null };
  },
  watch: {
    data: { handler() { this.render(); }, deep: true },
    type() { this.render(); },
  },
  methods: {
    render() {
      if (this.chart) {
        this.chart.destroy();
        this.chart = null;
      }
      if (!this.$refs.canvas) return;
      this.chart = new Chart(this.$refs.canvas, {
        type: this.type,
        data: this.data,
        options: Object.assign({ responsive: true, maintainAspectRatio: false }, this.options),
      });
    },
  },
  mounted() {
    this.render();
  },
  beforeDestroy() {
    if (this.chart) this.chart.destroy();
  },
};
</script>
